module.exports = __webpack_public_path__ + "static/media/dashboard_easy.68e6f920.png";